import { render, staticRenderFns } from "./weeklyCooking.vue?vue&type=template&id=28c68a23&scoped=true&"
import script from "./weeklyCooking.vue?vue&type=script&lang=js&"
export * from "./weeklyCooking.vue?vue&type=script&lang=js&"
import style0 from "./weeklyCooking.vue?vue&type=style&index=0&id=28c68a23&scoped=true&lang=css&"
import style1 from "./weeklyCooking.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c68a23",
  null
  
)

export default component.exports